var grey = {
  // Background
  50: "#f8f8f8",
  // Background
  100: "#f1f1f1",
  // Border, Disabled
  200: "#e3e3e3",
  // Closed, Inactive
  300: "#ababab",
  // Icon, Text – Body Secondary
  400: "#737373",
  // Icon, Text – Body
  500: "#505050",
  // Text – Heading, Body Dark
  600: "#232323"
};
export var colors = {
  blue: "#0a5fd2",
  bloodOrange: "#D44500",
  darkOrange: "#fa4616",
  green: "#008906",
  grey: grey,
  lightGreen: "#a5bb48",
  lightOrange: "#ffb432",
  purple: "#c34789",
  red: "#ec0000",
  white: "#ffffff"
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tdWktdGhlbWVzL2NvcmUvY29sb3JzLnRzIl0sIm5hbWVzIjpbImdyZXkiLCJjb2xvcnMiLCJibHVlIiwiYmxvb2RPcmFuZ2UiLCJkYXJrT3JhbmdlIiwiZ3JlZW4iLCJsaWdodEdyZWVuIiwibGlnaHRPcmFuZ2UiLCJwdXJwbGUiLCJyZWQiLCJ3aGl0ZSJdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTUEsSUFBSSxHQUFHO0FBQ1g7QUFDQSxNQUFJLFNBRk87QUFHWDtBQUNBLE9BQUssU0FKTTtBQUtYO0FBQ0EsT0FBSyxTQU5NO0FBT1g7QUFDQSxPQUFLLFNBUk07QUFTWDtBQUNBLE9BQUssU0FWTTtBQVdYO0FBQ0EsT0FBSyxTQVpNO0FBYVg7QUFDQSxPQUFLO0FBZE0sQ0FBYjtBQWlCQSxPQUFPLElBQU1DLE1BQU0sR0FBRztBQUNwQkMsRUFBQUEsSUFBSSxFQUFFLFNBRGM7QUFFcEJDLEVBQUFBLFdBQVcsRUFBRSxTQUZPO0FBR3BCQyxFQUFBQSxVQUFVLEVBQUUsU0FIUTtBQUlwQkMsRUFBQUEsS0FBSyxFQUFFLFNBSmE7QUFLcEJMLEVBQUFBLElBQUksRUFBSkEsSUFMb0I7QUFNcEJNLEVBQUFBLFVBQVUsRUFBRSxTQU5RO0FBT3BCQyxFQUFBQSxXQUFXLEVBQUUsU0FQTztBQVFwQkMsRUFBQUEsTUFBTSxFQUFFLFNBUlk7QUFTcEJDLEVBQUFBLEdBQUcsRUFBRSxTQVRlO0FBVXBCQyxFQUFBQSxLQUFLLEVBQUU7QUFWYSxDQUFmIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgZ3JleSA9IHtcbiAgLy8gQmFja2dyb3VuZFxuICA1MDogXCIjZjhmOGY4XCIsXG4gIC8vIEJhY2tncm91bmRcbiAgMTAwOiBcIiNmMWYxZjFcIixcbiAgLy8gQm9yZGVyLCBEaXNhYmxlZFxuICAyMDA6IFwiI2UzZTNlM1wiLFxuICAvLyBDbG9zZWQsIEluYWN0aXZlXG4gIDMwMDogXCIjYWJhYmFiXCIsXG4gIC8vIEljb24sIFRleHQg4oCTIEJvZHkgU2Vjb25kYXJ5XG4gIDQwMDogXCIjNzM3MzczXCIsXG4gIC8vIEljb24sIFRleHQg4oCTIEJvZHlcbiAgNTAwOiBcIiM1MDUwNTBcIixcbiAgLy8gVGV4dCDigJMgSGVhZGluZywgQm9keSBEYXJrXG4gIDYwMDogXCIjMjMyMzIzXCIsXG59O1xuXG5leHBvcnQgY29uc3QgY29sb3JzID0ge1xuICBibHVlOiBcIiMwYTVmZDJcIixcbiAgYmxvb2RPcmFuZ2U6IFwiI0Q0NDUwMFwiLFxuICBkYXJrT3JhbmdlOiBcIiNmYTQ2MTZcIixcbiAgZ3JlZW46IFwiIzAwODkwNlwiLFxuICBncmV5LFxuICBsaWdodEdyZWVuOiBcIiNhNWJiNDhcIixcbiAgbGlnaHRPcmFuZ2U6IFwiI2ZmYjQzMlwiLFxuICBwdXJwbGU6IFwiI2MzNDc4OVwiLFxuICByZWQ6IFwiI2VjMDAwMFwiLFxuICB3aGl0ZTogXCIjZmZmZmZmXCIsXG59O1xuIl19